// features/pricing/api/pricingApi.ts
import apiService from '../../../services/api';
import { CreateCheckoutSessionPayload, CreateCheckoutSessionResponse, PricingApiResponse } from '../model/PricingModel';


class PricingApi {
  async getPricingPlans(): Promise<PricingApiResponse> {
    const response = await apiService.get('/pricing/plans');
    return response.data;
  }

  async createCheckoutSession(payload: CreateCheckoutSessionPayload): Promise<CreateCheckoutSessionResponse> {
    const queryParams = new URLSearchParams({
      tier_id: payload.tier_id,
      billing_period: payload.billing_period,
      company_id: payload.company_id,
      success_url: payload.success_url,
      cancel_url: payload.cancel_url,
    }).toString();

    const response = await apiService.post(`/webhooks/stripe/create-checkout-session?${queryParams}`);
    return response.data;
  }
}
export const getCurrentPlan = async () => {
   return await apiService.get('/billing/current-plan');
  
}
export const  getBillingManagementLink = async (successUrl: string) => {
  return await apiService.post(`/webhooks/stripe/manage-billing?return_url=${encodeURIComponent(successUrl)}`);
}
export const downgradePlan = async (payload: { company_id: string; new_tier_id: string; billing_period: string }) => {
  const queryParams = new URLSearchParams({
    company_id: payload.company_id,
    new_tier_id: payload.new_tier_id,
    billing_period: payload.billing_period,
  }).toString();
  return await apiService.post(`/webhooks/stripe/downgrade-subscription?${queryParams}`);
}
export const upgradePlan = async (payload: { company_id: string; new_tier_id: string; billing_period: string }) => {
  const queryParams = new URLSearchParams({
    company_id: payload.company_id,
    new_tier_id: payload.new_tier_id,
    billing_period: payload.billing_period,
  }).toString();
  return await apiService.post(`/webhooks/stripe/upgrade-subscription?${queryParams}`);
}
export const switchBillingPeriod = async (payload: { company_id: string; current_tier_id: string; billing_period: string }) => {
  const queryParams = new URLSearchParams({
    company_id: payload.company_id,
    current_tier_id: payload.current_tier_id,
    billing_period: payload.billing_period,
  }).toString();
  return await apiService.post(`/webhooks/stripe/switch_billing_period?${queryParams}`);
}

// POST - /api/v1/
//    input: return_url- http://localhost:3000/company/flowsetting

export default new PricingApi();